import React from 'react';
import { css } from '@compiled/react';

import { QuickFeedbackComponent } from 'src/pages/LessonPage/children/QuickFeedbackComponent';

interface QuickFeedbackWrapperProps {
  isNextItemAvailable: boolean;
}

export const QuickFeedbackWrapper: React.FC<QuickFeedbackWrapperProps> = ({ isNextItemAvailable }) => (
  <div css={quickFeedbackContainer} data-testid="quick-feedback-section">
    <QuickFeedbackComponent shouldShowDivider={isNextItemAvailable} />
  </div>
);

const quickFeedbackContainer = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  maxWidth: '608px',
  width: '100%',
});
